import { chooseDefinition } from '@platform/core/lib/chooseDefinition';
import type { IModuleDefinitionState } from '@platform/core/types/modularity/IModuleDefinitionState';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { useGetModuleQuery } from '@platform/state/api';
import { isOfflineError } from './isOfflineError';
import { findModuleDefinition } from './moduleDefinitionRegistry';

/**
 * Визначення модуля для сторінок рушія (ADR-023): сервер повертає визначення, злите з налаштуваннями поточного простору маршруту (кеш — на
 * кожен простір окремо; після перемикання простору дані попереднього не показуються). Визначення з файлів пакета — лише миттєвий fallback,
 * доки сервер відповідає або коли він недоступний (мережа, 5xx); відповідь сервера 4xx — помилка сторінки, а не опубліковане визначення.
 */
export function useModuleDefinition(moduleKey: string): IModuleDefinitionState {
  const { ws } = useWorkspaceParams();
  const query = useGetModuleQuery({ key: moduleKey, workspaceId: ws || undefined }, { skip: !moduleKey });
  const pending = query.isLoading || query.isFetching;
  const fallback = pending || isOfflineError(query.error) ? findModuleDefinition(moduleKey) : undefined;
  return chooseDefinition({ data: query.currentData, isLoading: pending, error: query.currentData || pending ? undefined : query.error }, fallback);
}
